import React, { useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import RecommendationsSection from './Components/Recommendations/Recommendations.Section';
import InsightsSection from './Components/Insights/Insights.Section';
import Modal from './Components/Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchfetchDropTrackProduct, openModal, setActiveSection, setProductDetails } from '../../Features/dropTrackProductsSlice';
import TabButton from '../../Components/TabButton/TabButton';
import Loading from '../../Components/Loading/Loading';
import Error from '../../Components/Error/Error';
import { getProductByID } from '../../lib/utils/apiCalls';
import { getCachedMediaUrl } from '../../lib/utils/utils';

function DropTrackProductInsightPage() {
    const params = useParams();
    const dispatch = useDispatch();
    const location = useLocation();

    const dropTrackProduct = useSelector((state) => state.dropTrackProducts.dropTrackProduct.dropTrackProduct);
    const productDetails = useSelector((state) => state.dropTrackProducts.productDetails);

    const modalDisplay = useSelector((state) => state.dropTrackProducts.modalDisplay);
    const loading = useSelector((state) => state.dropTrackProducts.dropTrackProduct.loading);
    const error = useSelector((state) => state.dropTrackProducts.dropTrackProduct.error);

    const activeSection = useSelector((state) => state.dropTrackProducts.droptrackProductPage.activeSection);

    const updateActiveSection = (selection) => {
        dispatch(setActiveSection(selection));
    }

    useEffect(() => {
        params.productId && dispatch(fetchfetchDropTrackProduct(params.productId));
        // eslint-disable-next-line
    }, [params]);

    const handleButtonClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(openModal());
    };

    useEffect(() => {
        const getProduct = async () => {
            const response = await getProductByID(dropTrackProduct.productId);
            if(response?.status === 200) {
                dispatch(setProductDetails({
                    ...response?.data?.product,
                    imageUrl: getCachedMediaUrl(response?.data?.product.productImgUrls[0])
                }));
            }
        }

        Object.keys(dropTrackProduct).length > 0 && getProduct();
        // eslint-disable-next-line
    }, [dropTrackProduct]);

    if(error) {
        return (
            <Error 
                error={`Product with id: ${params.productId} not found!`} 
                pageName={'droptrack'} 
                pageLink={'/droptrack-products'} 
            />
        )
    }

    return (
        <>
            {
                loading === 'loading' ? 
                <Loading /> :
                <div className="w-full overflow-y-scroll pb-16">
                    <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                        <div className="w-fit flex items-center">
                            <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="p-[10px] flex items-center justify-center">
                                <img className='w-6 h-6 text-[#666666]' src={ArrowLeft} alt="" />
                            </Link>

                            <h1 className="p-[6px] text-[#121212] font-bold text-2xl select-none">{productDetails?.productName}</h1>
                        </div>

                        <button onClick={handleButtonClick} className='bg-primaryColor hover:bg-primaryAccent rounded-md px-3 py-[10px] text-buttonText font-semibold text-[14px] leading-[22px] select-none outline-none'>
                            Take Action
                        </button>
                    </div>

                    <div className="flex border-b-2 border-[#F5F5F5] m-[0px_19px_0px_20px]">
                        <TabButton 
                            id='recommendations' 
                            optionName='Recommendations' 
                            selected={activeSection} 
                            handleSelect={updateActiveSection} 
                        />
                        <TabButton 
                            id='insights' 
                            optionName='Insights' 
                            selected={activeSection} 
                            handleSelect={updateActiveSection} 
                        />
                    </div>

                    <div className="flex flex-col">
                        {activeSection === 'recommendations' && <RecommendationsSection />}

                        {activeSection === 'insights' && <InsightsSection />}
                    </div>

                    {modalDisplay && <Modal />}
                </div>
            }
        </>
    );
}

export default DropTrackProductInsightPage;
